import React from "react";
import ModalCard from "./modal-card";
import StarBoostControl from "../molecules/leader-board/star-boost-control";

interface StarVoteProps {
  className?: string;
  onClose: () => void;
  onClick: (rating: number) => void;
}

const StarVote = ({ className, onClose, onClick }: StarVoteProps) => {
  return (
    <ModalCard title="Vote" onClose={onClose} className={className}>
      <StarBoostControl onSend={onClick} />
    </ModalCard>
  );
};

export default StarVote;
